import { Outlet } from 'react-router-dom'
import NavigationDrawer from './navigation-drawer'
import Topline from './topline'

export default function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-surface-page">
      <NavigationDrawer />
      <main className="flex-1 flex flex-col overflow-hidden lg:ml-[248px]">
        <Topline />
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
